import React from 'react';
export const useGridDropdown = (value, gridDropdownProps) => {
    const [useHoverOver, setUserHoverOver] = React.useState(false);
    const handleOptionSelection = React.useCallback((optionValue) => {
        if (!gridDropdownProps ||
            !gridDropdownProps.handleOptionSelectionWithRowValue)
            return;
        gridDropdownProps.handleOptionSelectionWithRowValue(value, optionValue);
    }, [value, gridDropdownProps]);
    const userHoverCell = () => setUserHoverOver(true);
    const userLeavesCell = () => setUserHoverOver(false);
    const showCellDropdown = React.useMemo(() => useHoverOver && !!gridDropdownProps, [useHoverOver, gridDropdownProps]);
    return {
        userHoverCell,
        userLeavesCell,
        showCellDropdown,
        handleOptionSelection,
    };
};
//# sourceMappingURL=useGridDropdown.js.map